<!-- RIGHT QUADRANT / TOOTH SIDE LABEL -->
@if (areLabelsDisplayedOnRightQuadrant()) {
  <div
    class="absolute -top-5 left-0 -ml-18 w-18 bg-background-light-blue pt-2 text-center"
    [class]="isQuadrantSelected() ? 'typo-h7-semibold h-20 rounded-t-2xl' : 'typo-h8-semibold h-12 rounded-t-xl'"
  >
    <h6 class="typo-h8-bold text-primary-blue">
      {{ toothSideLabel() | translate }}
    </h6>
  </div>
}

<!-- LEFT QUADRANT / TOOTH SIDE LABEL -->
@if (areLabelsDisplayedOnLeftQuadrant()) {
  <div
    class="absolute -top-5 right-0 -mr-18 w-18 bg-background-light-blue pt-2 text-center"
    [class]="isQuadrantSelected() ? 'typo-h7-semibold h-20 rounded-t-2xl' : 'typo-h8-semibold h-12 rounded-t-xl'"
  >
    <h6 class="typo-h8-bold text-primary-blue">
      {{ toothSideLabel() | translate }}
    </h6>
  </div>
}

<div
  class="current-background bg-blur-white-overlay grid h-full min-h-[56px] border-background-light-blue"
  [class]="isQuadrantSelected() ? 'rounded-[40px] border-4 after:rounded-t-[38px]' : 'rounded-[20px] border-2 after:rounded-t-[18px]'"
  [ngClass]="{ '-ml-18': areLabelsDisplayedOnRightQuadrant(), '-mr-18': areLabelsDisplayedOnLeftQuadrant() }"
>
  <div class="grid" [class]="areLabelsDisplayedOnRightQuadrant() ? 'grid-cols-[72px_repeat(8,1fr)]' : 'grid-cols-[repeat(8,1fr)_72px]'">
    <!-- RIGHT QUADRANT / CURRENT LABEL  -->
    @if (areLabelsDisplayedOnRightQuadrant()) {
      <div
        class="col-start-1 row-start-1 grid grid-rows-1 items-center justify-center text-right"
        [class]="isQuadrantSelected() ? 'typo-h7-semibold' : 'typo-h8-semibold'"
      >
        <h6>{{ 'perio_compare_label_current' | translate }}</h6>
      </div>
    }

    <!-- POCKET DEPTH SYMBOLS - CURRENT -->
    @for (tooth of currentTeeth(); track tooth.position) {
      <div class="grid grid-rows-1 border-background-light-blue" [class]="getBorderClass()">
        <div class="flex items-center justify-center">
          <div class="flex justify-center gap-2" [class]="isQuadrantSelected() ? 'h-8' : 'h-4'" [ngClass]="pocketDepthSymbolPosition()">
            @for (probingSite of getPocketDepths(tooth); track index; let index = $index) {
              <lib-pocket-depth-symbol
                [probingSite]="probingSite"
                [isQuadrantSelected]="isQuadrantSelected()"
                [overlayPosition]="overlayPosition()"
                [toothSide]="toothSide()"
                [exam]="'current'"
              >
              </lib-pocket-depth-symbol>
            }
          </div>
        </div>
      </div>
    }

    <!-- LEFT QUADRANT / CURRENT LABEL  -->
    @if (areLabelsDisplayedOnLeftQuadrant()) {
      <div
        class="col-end-[-1] row-start-1 grid grid-rows-1 items-center justify-center text-right"
        [class]="isQuadrantSelected() ? 'typo-h7-semibold' : 'typo-h8-semibold'"
      >
        <h6>{{ 'perio_compare_label_current' | translate }}</h6>
      </div>
    }

    <!-- RIGHT QUADRANT / PREVIOUS LABEL  -->
    @if (areLabelsDisplayedOnRightQuadrant()) {
      <div
        class="col-start-1 row-start-2 grid grid-rows-1 items-center justify-center text-right"
        [class]="isQuadrantSelected() ? 'typo-h7-semibold' : 'typo-h8-semibold'"
      >
        <h6>{{ 'perio_compare_label_previous' | translate }}</h6>
      </div>
    }

    <!-- POCKET DEPTH SYMBOLS - PREVIOUS -->
    @for (tooth of previousTeeth(); track tooth.position) {
      <div class="grid grid-rows-1 border-background-light-blue" [class]="getBorderClass()">
        <div class="flex items-center justify-center">
          <div class="flex justify-center gap-2" [ngClass]="pocketDepthSymbolPosition()">
            @for (probingSite of getPocketDepths(tooth); track index; let index = $index) {
              <lib-pocket-depth-symbol
                [probingSite]="probingSite"
                [isQuadrantSelected]="isQuadrantSelected()"
                [overlayPosition]="overlayPosition()"
                [toothSide]="toothSide()"
                [exam]="'previous'"
              >
              </lib-pocket-depth-symbol>
            }
          </div>
        </div>
      </div>
    }

    <!-- LEFT QUADRANT / PREVIOUS LABEL  -->
    @if (areLabelsDisplayedOnLeftQuadrant()) {
      <div
        class="col-end-[-1] row-start-2 grid grid-rows-1 items-center justify-center text-right"
        [class]="isQuadrantSelected() ? 'typo-h7-semibold' : 'typo-h8-semibold'"
      >
        <h6>{{ 'perio_compare_label_previous' | translate }}</h6>
      </div>
    }
  </div>
</div>
